import React from 'react'
import styled from 'styled-components'
import { ContainedButton } from 'irmlib/components/Controls'
import { YDivider } from 'irmlib/styles'
import { useHistory } from 'react-router-dom'

import { BaseCard, Table } from './BaseCard'
import * as routePaths from '../../../../navigation/routePaths'

const linksCardBodyContainerWidth = '220px'

const LinksCardBodyContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

const LinkCardButton = styled(ContainedButton)`
  width: ${linksCardBodyContainerWidth};
`

export const LinksCardBody = () => {
  const history = useHistory()

  const onClick = route => {
    history.push(route)
  }

  return (
    <LinksCardBodyContainer>
      <Table />
      <YDivider height='57px'/>
      <LinkCardButton id='dashBoard-createNewJob' onClick={() => onClick(routePaths.createJob)}>
        dashBoard.createNewJob
      </LinkCardButton>
      <YDivider height='26px'/>
      <LinkCardButton id='dashBoard-createNewTemplate' onClick={() => onClick(routePaths.createTemplate)}>
        dashBoard.createNewTemplate
      </LinkCardButton>
    </LinksCardBodyContainer>
  )
}

export const Links = () => {
  return (
    <BaseCard
      id='Links'
      body={<LinksCardBody />} 
      title='dashBoard.quickLinks' 
    />
  )
}
